<template>
  <a-modal
    :visible="visible"
    :title="modalTitle"
    width="900px"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="close">
    <!-- Tabs 切换 -->
    <a-tabs v-model="activeTab" @change="onTabChange">
      <a-tab-pane key="package" tab="安心套餐">
        <!-- 套餐搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="16">
              <a-col :md="8" :sm="24">
                <a-form-item label="套餐名称">
                  <a-input v-model="queryParam.packageName" placeholder="请输入" allow-clear @keyup.enter="getList" />
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <!-- 套餐表格 -->
        <a-table
          rowKey="id"
          :loading="loading"
          :columns="packageColumns"
          :data-source="packageList"
          :row-selection="rowSelection"
          :pagination="pagination"
          :scroll="{ x: 600 }"
          style="margin-top: 16px"
          @change="handleTableChange"
        >
          <!-- 套餐类型 -->
          <span slot="packageType" slot-scope="text, record">
            <span>{{ record.packageType | formStatus(packageType) }}</span>
          </span>

          <!-- 价格 -->
          <span slot="price" slot-scope="text"> ¥{{ text }} </span>

          <!-- 容量 -->
          <span slot="capacity" slot-scope="text">
            {{ $formatCapacity(text) }}
          </span>

          <!-- 状态 -->
          <span slot="status" slot-scope="text">
            <a-badge :status="text === 1 ? 'processing' : 'default'" />
            {{ text === 1 ? '启用' : '禁用' }}
          </span>
        </a-table>
      </a-tab-pane>

      <a-tab-pane key="flexible" tab="灵活套餐">
        <!-- 灵活套餐搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="16">
              <a-col :md="8" :sm="24">
                <a-form-item label="套餐名称">
                  <a-input
                    v-model="flexibleQueryParam.packageName"
                    placeholder="请输入"
                    allow-clear
                    @keyup.enter="getFlexibleList"
                  />
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-button type="primary" @click="handleFlexibleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetFlexibleQuery"><a-icon type="redo" />重置</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <!-- 灵活套餐表格 -->
        <a-table
          rowKey="id"
          :loading="flexibleLoading"
          :columns="flexibleColumns"
          :data-source="flexibleList"
          :row-selection="flexibleRowSelection"
          :pagination="flexiblePagination"
          :scroll="{ x: 600 }"
          style="margin-top: 16px"
          @change="handleFlexibleTableChange"
        >
          <!-- 套餐类型 -->
          <span slot="packageType" slot-scope="text, record">
            <span>{{ record.packageType | formStatus(packageType) }}</span>
          </span>

          <!-- 价格 -->
          <span slot="price" slot-scope="text"> ¥{{ text }} </span>

          <!-- 容量 -->
          <span slot="capacity" slot-scope="text">
            {{ $formatCapacity(text) }}
          </span>

          <!-- 状态 -->
          <span slot="status" slot-scope="text">
            <a-badge :status="text === 1 ? 'processing' : 'default'" />
            {{ text === 1 ? '启用' : '禁用' }}
          </span>
        </a-table>
      </a-tab-pane>

      <a-tab-pane key="expansion" tab="扩容包">
        <!-- 扩容包搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="16">
              <a-col :md="8" :sm="24">
                <a-form-item label="扩容包名称">
                  <a-input
                    v-model="expansionQueryParam.packageName"
                    placeholder="请输入"
                    allow-clear
                    @keyup.enter="getExpansionList"
                  />
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-button type="primary" @click="handleExpansionQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetExpansionQuery"><a-icon type="redo" />重置</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <!-- 扩容包表格 -->
        <a-table
          rowKey="id"
          :loading="expansionLoading"
          :columns="expansionColumns"
          :data-source="expansionList"
          :row-selection="expansionRowSelection"
          :pagination="expansionPagination"
          :scroll="{ x: 600 }"
          style="margin-top: 16px"
          @change="handleExpansionTableChange"
        >
          <!-- 扩容包类型 -->
          <span slot="packageType" slot-scope="text, record">
            <span>{{ record.packageType | formStatus(packageType) }}</span>
          </span>

          <!-- 价格 -->
          <span slot="price" slot-scope="text"> ¥{{ text }} </span>

          <!-- 容量 -->
          <span slot="capacity" slot-scope="text">
            {{ $formatCapacity(text) }}
          </span>

          <!-- 状态 -->
          <span slot="status" slot-scope="text">
            <a-badge :status="text === 1 ? 'processing' : 'default'" />
            {{ text === 1 ? '启用' : '禁用' }}
          </span>
        </a-table>
      </a-tab-pane>
    </a-tabs>

    <!-- 底部操作 -->
    <div slot="footer">
      <a-space>
        <span>已选择 {{ totalSelectedCount }} 个项目</span>
        <a-button @click="close">取消</a-button>
        <a-button type="primary" @click="handleOk">确定</a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import { fetchList } from '@/api/VR/storagePackage'
import { tableMixin } from '@/store/table-mixin'
import parameter from '@/mixins/parameter'

export default {
  name: 'PanoramaPackageSelectModal',
  mixins: [tableMixin, parameter],
  props: {
    visible: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    // 添加 modalTitle 属性以便父组件传递标题
    modalTitle: { type: String, default: '选择全景套餐' },
  },
  data() {
    return {
      activeTab: 'package', // 当前激活的标签页
      loading: false,
      expansionLoading: false,
      flexibleLoading: false,
      packageList: [],
      expansionList: [],
      flexibleList: [],
      selectedRows: [], // 套餐选择的行
      selectedExpansionRows: [], // 扩容包选择的行
      selectedFlexibleRows: [], // 灵活套餐选择的行

      // 套餐查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        packageName: undefined,
        packageType: 1,
        status: 1,
      },

      // 灵活套餐查询参数
      flexibleQueryParam: {
        pageNum: 1,
        pageSize: 10,
        packageName: undefined,
        packageType: 2,
        status: 1,
      },

      // 扩容包查询参数
      expansionQueryParam: {
        pageNum: 1,
        pageSize: 10,
        packageName: undefined,
        packageType: 3,
        status: 1,
      },

      // 套餐分页
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },

      // 扩容包分页
      expansionPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },

      // 灵活套餐分页
      flexiblePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },

      // 套餐表格列
      packageColumns: [
        {
          title: '套餐名称',
          dataIndex: 'packageName',
          align: 'center',
          ellipsis: true,
          width: 150,
        },
        {
          title: '套餐类型',
          dataIndex: 'packageType',
          scopedSlots: { customRender: 'packageType' },
          align: 'center',
          width: 100,
        },
        {
          title: '价格',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          align: 'center',
          width: 100,
        },
        {
          title: '容量',
          dataIndex: 'capacity',
          scopedSlots: { customRender: 'capacity' },
          align: 'center',
          width: 100,
        },
        {
          title: '有效期',
          dataIndex: 'validDays',
          align: 'center',
          width: 80,
          customRender: (text) => (text ? `${text}天` : '永久'),
        },
      ],

      // 灵活套餐表格列
      flexibleColumns: [
        {
          title: '套餐名称',
          dataIndex: 'packageName',
          align: 'center',
          ellipsis: true,
          width: 150,
        },
        {
          title: '套餐类型',
          dataIndex: 'packageType',
          scopedSlots: { customRender: 'packageType' },
          align: 'center',
          width: 100,
        },
        {
          title: '价格',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          align: 'center',
          width: 100,
        },
        {
          title: '容量',
          dataIndex: 'capacity',
          scopedSlots: { customRender: 'capacity' },
          align: 'center',
          width: 100,
        },
        {
          title: '有效期',
          dataIndex: 'validDays',
          align: 'center',
          width: 80,
          customRender: (text, record) => {
            if (record.packageType === 3) {
              console.log(record.packageType, 222)
              return '随套餐'
            }
            return text ? `${text}天` : '永久'
          },
        },
      ],

      // 扩容包表格列
      expansionColumns: [
        {
          title: '扩容包名称',
          dataIndex: 'packageName',
          align: 'center',
          ellipsis: true,
          width: 150,
        },
        {
          title: '扩容包类型',
          dataIndex: 'packageType',
          scopedSlots: { customRender: 'packageType' },
          align: 'center',
          width: 100,
        },
        {
          title: '价格',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          align: 'center',
          width: 100,
        },
        {
          title: '容量',
          dataIndex: 'capacity',
          scopedSlots: { customRender: 'capacity' },
          align: 'center',
          width: 100,
        },
        {
          title: '有效期',
          dataIndex: 'validDays',
          align: 'center',
          width: 80,
          customRender: (text, record) => {
            if (record.packageType === 3) {
              console.log(record.packageType, 222)
              return '随套餐'
            }
            return text ? `${text}天` : '永久'
          },
        },
      ],

      // 扩容包类型选项
      expansionPackageTypes: [
        { id: 1, name: '基础扩容包' },
        { id: 2, name: '高级扩容包' },
        { id: 3, name: '专业扩容包' },
      ],
    }
  },
  computed: {
    // 套餐选择配置
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRows.map((r) => r.id),
        onChange: this.onSelectChange,
        type: 'checkbox',
      }
    },

    // 扩容包选择配置
    expansionRowSelection() {
      return {
        selectedRowKeys: this.selectedExpansionRows.map((r) => r.id),
        onChange: this.onExpansionSelectChange,
        type: 'checkbox',
      }
    },

    // 灵活套餐选择配置
    flexibleRowSelection() {
      return {
        selectedRowKeys: this.selectedFlexibleRows.map((r) => r.id),
        onChange: this.onFlexibleSelectChange,
        type: 'checkbox',
      }
    },

    // 总选择数量
    totalSelectedCount() {
      return this.selectedRows.length + this.selectedExpansionRows.length + this.selectedFlexibleRows.length
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        if (v) {
          // 深拷贝避免引用问题
          this.selectedRows = JSON.parse(JSON.stringify(this.value.filter((item) => item.productType === 1)))
          this.selectedExpansionRows = JSON.parse(JSON.stringify(this.value.filter((item) => item.productType === 2)))
          this.selectedFlexibleRows = JSON.parse(JSON.stringify(this.value.filter((item) => item.productType === 3)))
          // 弹窗打开时立即请求固定套餐数据
          this.getList()
        } else {
          this.selectedRows = []
          this.selectedExpansionRows = []
          this.selectedFlexibleRows = []
          // 重置搜索条件
          this.resetQuery()
          this.resetExpansionQuery()
          this.resetFlexibleQuery()
        }
      },
    },
    // 监听 value 变化，确保外部数据同步
    value: {
      deep: true,
      handler(newVal) {
        if (this.visible) {
          this.selectedRows = JSON.parse(JSON.stringify(newVal.filter((item) => item.productType === 1)))
          this.selectedExpansionRows = JSON.parse(JSON.stringify(newVal.filter((item) => item.productType === 2)))
          this.selectedFlexibleRows = JSON.parse(JSON.stringify(newVal.filter((item) => item.productType === 3)))
        }
      },
    },
  },
  methods: {
    // Tab 切换处理
    onTabChange(activeKey) {
      this.activeTab = activeKey
      // 每次切换tab都重新调用接口
      if (activeKey === 'package') {
        this.resetQuery()
        this.getList()
      } else if (activeKey === 'flexible') {
        this.resetFlexibleQuery()
        this.getFlexibleList()
      } else if (activeKey === 'expansion') {
        this.resetExpansionQuery()
        this.getExpansionList()
      }
    },

    // 获取套餐类型颜色
    getPackageTypeColor(type) {
      const colors = {
        1: 'blue',
        2: 'green',
        3: 'orange',
      }
      return colors[type] || 'default'
    },

    // 获取套餐类型文本
    getPackageTypeText(type) {
      const texts = {
        1: '基础套餐',
        2: '高级套餐',
        3: '专业套餐',
      }
      return texts[type] || '未知类型'
    },

    // 获取扩容包类型颜色
    getExpansionPackageTypeColor(type) {
      const colors = {
        1: 'cyan',
        2: 'purple',
        3: 'red',
      }
      return colors[type] || 'default'
    },

    // 获取扩容包类型文本
    getExpansionPackageTypeText(type) {
      const texts = {
        1: '基础扩容包',
        2: '高级扩容包',
        3: '专业扩容包',
      }
      return texts[type] || '未知类型'
    },

    // 格式化容量显示
    formatCapacity(capacity) {
      if (capacity >= 1024) {
        return (capacity / 1024).toFixed(1) + 'GB'
      }
      return capacity + 'MB'
    },

    // 套餐选择变化
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRows
    },

    // 扩容包选择变化
    onExpansionSelectChange(selectedRowKeys, selectedRows) {
      this.selectedExpansionRows = selectedRows
    },

    // 灵活套餐选择变化
    onFlexibleSelectChange(selectedRowKeys, selectedRows) {
      this.selectedFlexibleRows = selectedRows
    },

    // 获取套餐列表
    getList() {
      this.loading = true
      fetchList(this.queryParam)
        .then((res) => {
          if (res.data && res.data.records) {
            this.packageList = res.data.records
            this.pagination.total = res.data.total || 0
            this.pagination.current = this.queryParam.pageNum
          } else {
            this.packageList = []
            this.pagination.total = 0
          }
        })
        .catch((error) => {
          console.error('获取套餐列表失败:', error)
          this.packageList = []
          this.pagination.total = 0
        })
        .finally(() => (this.loading = false))
    },

    // 获取扩容包列表
    getExpansionList() {
      this.expansionLoading = true
      fetchList(this.expansionQueryParam)
        .then((res) => {
          if (res.data && res.data.records) {
            this.expansionList = res.data.records
            this.expansionPagination.total = res.data.total || 0
            this.expansionPagination.current = this.expansionQueryParam.pageNum
          } else {
            this.expansionList = []
            this.expansionPagination.total = 0
          }
        })
        .catch((error) => {
          console.error('获取扩容包列表失败:', error)
          this.expansionList = []
          this.expansionPagination.total = 0
        })
        .finally(() => (this.expansionLoading = false))
    },

    // 获取灵活套餐列表
    getFlexibleList() {
      this.flexibleLoading = true
      fetchList(this.flexibleQueryParam)
        .then((res) => {
          if (res.data && res.data.records) {
            this.flexibleList = res.data.records
            this.flexiblePagination.total = res.data.total || 0
            this.flexiblePagination.current = this.flexibleQueryParam.pageNum
          } else {
            this.flexibleList = []
            this.flexiblePagination.total = 0
          }
        })
        .catch((error) => {
          console.error('获取灵活套餐列表失败:', error)
          this.flexibleList = []
          this.flexiblePagination.total = 0
        })
        .finally(() => (this.flexibleLoading = false))
    },

    // 套餐查询
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    // 扩容包查询
    handleExpansionQuery() {
      this.expansionQueryParam.pageNum = 1
      this.getExpansionList()
    },

    // 灵活套餐查询
    handleFlexibleQuery() {
      this.flexibleQueryParam.pageNum = 1
      this.getFlexibleList()
    },

    // 重置套餐查询
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        packageName: undefined,
        packageType: 1,
        status: 1,
        productType: 1,
      }
      // 只有在可见状态下才重新获取列表
      if (this.visible && this.activeTab === 'package') {
        this.getList()
      }
    },

    // 重置扩容包查询
    resetExpansionQuery() {
      this.expansionQueryParam = {
        pageNum: 1,
        pageSize: 10,
        packageName: undefined,
        packageType: 3,
        status: 1,
      }
      // 只有在可见状态下才重新获取列表
      if (this.visible && this.activeTab === 'expansion') {
        this.getExpansionList()
      }
    },

    // 重置灵活套餐查询
    resetFlexibleQuery() {
      this.flexibleQueryParam = {
        pageNum: 1,
        pageSize: 10,
        packageName: undefined,
        packageType: 2,
        status: 1,
      }
      // 只有在可见状态下才重新获取列表
      if (this.visible && this.activeTab === 'flexible') {
        this.getFlexibleList()
      }
    },

    // 套餐表格分页变化
    handleTableChange(pager) {
      this.queryParam.pageNum = pager.current
      this.queryParam.pageSize = pager.pageSize
      this.pagination = { ...this.pagination, ...pager }
      this.getList()
    },

    // 扩容包表格分页变化
    handleExpansionTableChange(pager) {
      this.expansionQueryParam.pageNum = pager.current
      this.expansionQueryParam.pageSize = pager.pageSize
      this.expansionPagination = { ...this.expansionPagination, ...pager }
      this.getExpansionList()
    },

    // 灵活套餐表格分页变化
    handleFlexibleTableChange(pager) {
      this.flexibleQueryParam.pageNum = pager.current
      this.flexibleQueryParam.pageSize = pager.pageSize
      this.flexiblePagination = { ...this.flexiblePagination, ...pager }
      this.getFlexibleList()
    },

    // 确定选择
    handleOk() {
      // 合并套餐和扩容包数据
      const allSelectedData = [
        ...this.selectedRows.map((row) => ({
          ...row,
          productType: 1, // 标记为固定套餐
          typeName: '固定套餐',
        })),
        ...this.selectedFlexibleRows.map((row) => ({
          ...row,
          productType: 3, // 标记为灵活套餐
          typeName: '灵活套餐',
        })),
        ...this.selectedExpansionRows.map((row) => ({
          ...row,
          productType: 2, // 标记为扩容包
          typeName: '扩容包',
        })),
      ]

      this.$emit('input', allSelectedData)
      this.$emit('ok', allSelectedData)
      this.close()
    },

    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-wrapper .ant-form-item {
  margin-bottom: 16px;
}

.ant-table-thead > tr > th {
  background-color: #fafafa;
  font-weight: 600;
}

.ant-tabs {
  margin-top: -16px;
}
</style>
